import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { GlobalStyle } from './Components/Common__style/GlobalStyle';
import Header from './Components/Header/Header';
import Menu from './Components/Menu/Menu';
import Story from './Components/Story/Story';
import Capabilities from './Components/Capabilities/Capabilities';
import Illustration from './Components/Illustration/Illustration';
import Signup from './Components/Signup/Signup';
import Footer from './Components/Footer/Footer';
import Copyright from './Components/Copyright/Copyright';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  //<React.StrictMode>
  <>
    <GlobalStyle />
    <App />
  </>
  //</React.StrictMode>
);

function App() {
  return (
    <>
      <Header />
      <main>
        <Menu />
        <Story />
        <Capabilities />
        <Illustration />
        <Signup />
      </main>
      <Footer />
      <Copyright />
    </>
  )
}

